/**
 *   Generated file. Do not edit
 */
import { TapResponse } from '@iotize/tap';
import { SERVICE_CALLS } from './service-calls';

import { AbstractService, ServiceCallType } from '@iotize/tap';

export class MqttService extends AbstractService {
  public resources = SERVICE_CALLS;

  /**
   * Get mqtt relay client id
   *
   * LWM2M path: /1024//52
   *
   * @tapVersion(">=1.86")
   * @return
   */
  getClientId(): Promise<TapResponse<string>> {
    return this.serviceCallRunner.execute(this.getClientIdCall());
  }

  /**
   *
   *
   * LWM2M path: /1024//52
   *
   * @tapVersion(">=1.86")
   * @return call options
   */
  getClientIdCall(): ServiceCallType {
    const callOptions = { ...this.resources.getClientId };

    return callOptions;
  }

  /**
   * Set mqtt relay client id
   *
   * LWM2M path: /1024//52
   *
   * @tapVersion(">=1.86")
   * @param url input
   * @return
   */
  putClientId(
    /*
     *
     */
    url: string,
  ): Promise<TapResponse<void>> {
    return this.serviceCallRunner.execute(this.putClientIdCall(url));
  }

  /**
   *
   *
   * LWM2M path: /1024//52
   *
   * @tapVersion(">=1.86")
   * @param url input
   * @return call options
   */
  putClientIdCall(
    /*
     *
     */
    url: string,
  ): ServiceCallType {
    const callOptions = { ...this.resources.putClientId };

    callOptions.body = url;

    return callOptions;
  }

  /**
   * Get mqtt relay login. For firmware version <= 1.86, use serial number (resource /3//2)
   *
   * LWM2M path: /1024//53
   *
   * @deprecated
   * @tapVersion(">=1.86")
   * @return
   */
  getUsername(): Promise<TapResponse<string>> {
    return this.serviceCallRunner.execute(this.getUsernameCall());
  }

  /**
   *
   *
   * LWM2M path: /1024//53
   *
   * @deprecated
   * @tapVersion(">=1.86")
   * @return call options
   */
  getUsernameCall(): ServiceCallType {
    const callOptions = { ...this.resources.getUsername };

    return callOptions;
  }

  /**
   * Write mqtt relay password id. For firmware version <= 1.86, use serial number (resource /3//2)
   *
   * LWM2M path: /1024//53
   *
   * @tapVersion(">=1.86")
   * @param url input
   * @return
   */
  putUsername(
    /*
     *
     */
    url: string,
  ): Promise<TapResponse<void>> {
    return this.serviceCallRunner.execute(this.putUsernameCall(url));
  }

  /**
   *
   *
   * LWM2M path: /1024//53
   *
   * @tapVersion(">=1.86")
   * @param url input
   * @return call options
   */
  putUsernameCall(
    /*
     *
     */
    url: string,
  ): ServiceCallType {
    const callOptions = { ...this.resources.putUsername };

    callOptions.body = url;

    return callOptions;
  }

  /**
   * Get mqtt broker hostname
   *
   * LWM2M path: /1024//50
   *
   * @tapVersion(">=1.0")
   * @return
   */
  getBrokerHostname(): Promise<TapResponse<string>> {
    return this.serviceCallRunner.execute(this.getBrokerHostnameCall());
  }

  /**
   *
   *
   * LWM2M path: /1024//50
   *
   * @tapVersion(">=1.0")
   * @return call options
   */
  getBrokerHostnameCall(): ServiceCallType {
    const callOptions = { ...this.resources.getBrokerHostname };

    return callOptions;
  }

  /**
   * Write mqtt relay host
   *
   * LWM2M path: /1024//50
   *
   * @tapVersion(">=1.0")
   * @param url input
   * @return
   */
  putBrokerHostname(
    /*
     *
     */
    url: string,
  ): Promise<TapResponse<void>> {
    return this.serviceCallRunner.execute(this.putBrokerHostnameCall(url));
  }

  /**
   *
   *
   * LWM2M path: /1024//50
   *
   * @tapVersion(">=1.0")
   * @param url input
   * @return call options
   */
  putBrokerHostnameCall(
    /*
     *
     */
    url: string,
  ): ServiceCallType {
    const callOptions = { ...this.resources.putBrokerHostname };

    callOptions.body = url;

    return callOptions;
  }

  /**
   * Get port of the mqtt broker
   *
   * LWM2M path: /1024//51
   *
   * @tapVersion(">=1.0")
   * @return
   */
  getBrokerPort(): Promise<TapResponse<string>> {
    return this.serviceCallRunner.execute(this.getBrokerPortCall());
  }

  /**
   *
   *
   * LWM2M path: /1024//51
   *
   * @tapVersion(">=1.0")
   * @return call options
   */
  getBrokerPortCall(): ServiceCallType {
    const callOptions = { ...this.resources.getBrokerPort };

    return callOptions;
  }

  /**
   * Write service name of the mqtt broker
   *
   * LWM2M path: /1024//51
   *
   * @tapVersion(">=1.0")
   * @param url input
   * @return
   */
  putBrokerPort(
    /*
     *
     */
    url: string,
  ): Promise<TapResponse<void>> {
    return this.serviceCallRunner.execute(this.putBrokerPortCall(url));
  }

  /**
   *
   *
   * LWM2M path: /1024//51
   *
   * @tapVersion(">=1.0")
   * @param url input
   * @return call options
   */
  putBrokerPortCall(
    /*
     *
     */
    url: string,
  ): ServiceCallType {
    const callOptions = { ...this.resources.putBrokerPort };

    callOptions.body = url;

    return callOptions;
  }

  /**
   * Get the mqtt broker password
   *
   * LWM2M path: /1024//54
   *
   * @tapVersion(">=1.0")
   * @return
   */
  getPassword(): Promise<TapResponse<string>> {
    return this.serviceCallRunner.execute(this.getPasswordCall());
  }

  /**
   *
   *
   * LWM2M path: /1024//54
   *
   * @tapVersion(">=1.0")
   * @return call options
   */
  getPasswordCall(): ServiceCallType {
    const callOptions = { ...this.resources.getPassword };

    return callOptions;
  }

  /**
   * Write mqtt broker password
   *
   * LWM2M path: /1024//54
   *
   * @tapVersion(">=1.0")
   * @param url input
   * @return
   */
  putPassword(
    /*
     *
     */
    url: string,
  ): Promise<TapResponse<void>> {
    return this.serviceCallRunner.execute(this.putPasswordCall(url));
  }

  /**
   *
   *
   * LWM2M path: /1024//54
   *
   * @tapVersion(">=1.0")
   * @param url input
   * @return call options
   */
  putPasswordCall(
    /*
     *
     */
    url: string,
  ): ServiceCallType {
    const callOptions = { ...this.resources.putPassword };

    callOptions.body = url;

    return callOptions;
  }

  /**
   * Get the mqtt relay net key
   *
   * LWM2M path: /1024//55
   *
   * @tapVersion(">=1.0")
   * @return
   */
  getRelayNetKey(): Promise<TapResponse<string>> {
    return this.serviceCallRunner.execute(this.getRelayNetKeyCall());
  }

  /**
   *
   *
   * LWM2M path: /1024//55
   *
   * @tapVersion(">=1.0")
   * @return call options
   */
  getRelayNetKeyCall(): ServiceCallType {
    const callOptions = { ...this.resources.getRelayNetKey };

    return callOptions;
  }

  /**
   * Write mqtt relay net key
   *
   * LWM2M path: /1024//55
   *
   * @tapVersion(">=1.0")
   * @param netkey input
   * @return
   */
  putRelayNetKey(
    /*
     *
     */
    netkey: string,
  ): Promise<TapResponse<void>> {
    return this.serviceCallRunner.execute(this.putRelayNetKeyCall(netkey));
  }

  /**
   *
   *
   * LWM2M path: /1024//55
   *
   * @tapVersion(">=1.0")
   * @param netkey input
   * @return call options
   */
  putRelayNetKeyCall(
    /*
     *
     */
    netkey: string,
  ): ServiceCallType {
    const callOptions = { ...this.resources.putRelayNetKey };

    callOptions.body = netkey;

    return callOptions;
  }

  /**
   * Set MQTT broker certificate data
   *
   * LWM2M path: /1024//57
   *
   * @tapVersion(">=1.86")
   * @param value input
   * @return
   */
  putBrokerCertificate(
    /*
     * Up to 16kB
     */
    value: Uint8Array,
  ): Promise<TapResponse<void>> {
    return this.serviceCallRunner.execute(this.putBrokerCertificateCall(value));
  }

  putBrokerCertificateAppendCalls(
    /*
     * Up to 16kB
     */
    value: Uint8Array,
    chunkSize?: number,
  ) {
    return this.serviceCallRunner.createAppendCalls(
      this.putBrokerCertificateCall(value),
      chunkSize,
    );
  }

  /**
   *
   *
   * LWM2M path: /1024//57
   *
   * @tapVersion(">=1.86")
   * @param value input
   * @return call options
   */
  putBrokerCertificateCall(
    /*
     * Up to 16kB
     */
    value: Uint8Array,
  ): ServiceCallType {
    const callOptions = { ...this.resources.putBrokerCertificate };

    callOptions.body = value;

    return callOptions;
  }

  /**
   * Get MQTT relay topic prefix
   *
   * LWM2M path: /1024//58
   *
   * @tapVersion(">=1.86")
   * @return
   */
  getTopicPrefix(): Promise<TapResponse<string>> {
    return this.serviceCallRunner.execute(this.getTopicPrefixCall());
  }

  /**
   *
   *
   * LWM2M path: /1024//58
   *
   * @tapVersion(">=1.86")
   * @return call options
   */
  getTopicPrefixCall(): ServiceCallType {
    const callOptions = { ...this.resources.getTopicPrefix };

    return callOptions;
  }

  /**
   * Put MQTT relay topic prefix
   *
   * LWM2M path: /1024//58
   *
   * @tapVersion(">=1.86")
   * @param topicPrefix input
   * @return
   */
  putTopicPrefix(
    /*
     *
     */
    topicPrefix: string,
  ): Promise<TapResponse<void>> {
    return this.serviceCallRunner.execute(this.putTopicPrefixCall(topicPrefix));
  }

  /**
   *
   *
   * LWM2M path: /1024//58
   *
   * @tapVersion(">=1.86")
   * @param topicPrefix input
   * @return call options
   */
  putTopicPrefixCall(
    /*
     *
     */
    topicPrefix: string,
  ): ServiceCallType {
    const callOptions = { ...this.resources.putTopicPrefix };

    callOptions.body = topicPrefix;

    return callOptions;
  }

  /**
   * Get mqtt request topic
   *
   * LWM2M path: /1024//58
   *
   * @tapVersion(">=1.86")
   * @return
   */
  getRequestTopic(): Promise<TapResponse<string>> {
    return this.serviceCallRunner.execute(this.getRequestTopicCall());
  }

  /**
   *
   *
   * LWM2M path: /1024//58
   *
   * @tapVersion(">=1.86")
   * @return call options
   */
  getRequestTopicCall(): ServiceCallType {
    const callOptions = { ...this.resources.getRequestTopic };

    return callOptions;
  }

  /**
   * Put mqtt request topic
   *
   * LWM2M path: /1024//58
   *
   * @tapVersion(">=1.86")
   * @param topic input
   * @return
   */
  putRequestTopic(
    /*
     *
     */
    topic: string,
  ): Promise<TapResponse<void>> {
    return this.serviceCallRunner.execute(this.putRequestTopicCall(topic));
  }

  /**
   *
   *
   * LWM2M path: /1024//58
   *
   * @tapVersion(">=1.86")
   * @param topic input
   * @return call options
   */
  putRequestTopicCall(
    /*
     *
     */
    topic: string,
  ): ServiceCallType {
    const callOptions = { ...this.resources.putRequestTopic };

    callOptions.body = topic;

    return callOptions;
  }

  /**
   * Get MQTT response topic
   *
   * LWM2M path: /1024//59
   *
   * @tapVersion(">=1.107")
   * @return
   */
  getResponseTopic(): Promise<TapResponse<string>> {
    return this.serviceCallRunner.execute(this.getResponseTopicCall());
  }

  /**
   *
   *
   * LWM2M path: /1024//59
   *
   * @tapVersion(">=1.107")
   * @return call options
   */
  getResponseTopicCall(): ServiceCallType {
    const callOptions = { ...this.resources.getResponseTopic };

    return callOptions;
  }

  /**
   * Put MQTT response topic
   *
   * LWM2M path: /1024//59
   *
   * @tapVersion(">=1.107")
   * @param topic input
   * @return
   */
  putResponseTopic(
    /*
     *
     */
    topic: string,
  ): Promise<TapResponse<void>> {
    return this.serviceCallRunner.execute(this.putResponseTopicCall(topic));
  }

  /**
   *
   *
   * LWM2M path: /1024//59
   *
   * @tapVersion(">=1.107")
   * @param topic input
   * @return call options
   */
  putResponseTopicCall(
    /*
     *
     */
    topic: string,
  ): ServiceCallType {
    const callOptions = { ...this.resources.putResponseTopic };

    callOptions.body = topic;

    return callOptions;
  }
}
